import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { NetWorthProvider } from "@/context/NetWorthContext";
import { Header } from "@/components/Header";
import Home from "@/pages/Home";
import Lineage from "@/pages/Lineage";
import Join from "@/pages/Join";
import Approvals from "@/pages/Approvals";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Album from "@/pages/Album";
import Celebrations from "@/pages/Celebrations";
import PrintTree from "@/pages/PrintTree";
import Relations from "@/pages/Relations";
import Events from "@/pages/Events";
import History from "@/pages/History";
import { getLang } from "@/lib/i18n";
import { t } from "@/lib/i18n";

function AppRouter() {
  const location = useLocation();
  const [, setLang] = useState(getLang());
  useEffect(() => {
    const on = () => setLang(getLang());
    window.addEventListener("langchange", on);
    return () => window.removeEventListener("langchange", on);
  }, []);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <div key={getLang()}>
      <Header />
      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/person/:id" element={<Lineage />} />
          <Route path="/join" element={<Join />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/album" element={<Album />} />
          <Route path="/celebrations" element={<Celebrations />} />
          <Route path="/print" element={<PrintTree />} />
          <Route path="/relations" element={<Relations />} />
          <Route path="/events" element={<Events />} />
          <Route path="/history" element={<History />} />
          <Route path="*" element={
            <section className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
              <h1 className="font-serif text-4xl font-bold text-[#1E3A2B]">{t("Page not found")}</h1>
              <Link to="/" className="inline-block mt-6 rounded-full bg-[#1E3A2B] text-[#FDFBF7] px-6 py-2.5" data-testid="not-found-home-link">{t("Back to the tree")}</Link>
            </section>
          } />
        </Routes>
      </main>
      <footer className="border-t border-[#E5DEC9] mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 flex justify-between text-sm text-[#7E8E85]">
          <span className="font-serif">{t("Vats Family Tree")}</span>
          <span className="font-mono text-xs uppercase tracking-[0.2em]">{t("Life long Jurny")}</span>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <div className="grain">
      <BrowserRouter>
        <AuthProvider>
          <NetWorthProvider>
            <AppRouter />
          </NetWorthProvider>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
